import React, { useState } from "react"
import { useHistory, useParams } from "react-router"
import { Box, Button } from "@material-ui/core"
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons"
import CustomDialog from "../../components/CustomDialog"
import { useStyles } from './styles'
import one from '../../images/stepper/1.svg'
import two from '../../images/stepper/2.svg'
import three from '../../images/stepper/3.svg'
import four from '../../images/stepper/4.svg'
import stepper1 from '../../images/stepper/stepper1.svg'
import stepper2 from '../../images/stepper/stepper2.svg'
import stepper3 from '../../images/stepper/stepper3.svg'
import stepper4 from '../../images/stepper/stepper4.svg'
import DownloadFile from "../../Services/DownloadFile"

const Process = (props) => {
  const classes = useStyles()
  const history = useHistory()
  const [activeStep, setActiveStep] = useState(0)
  const { programId } = useParams()
  const steps = [
    {
      header: <>
        <Box className={classes.headerNumber}>
          <img src={one} className={classes.stepperNumberImg} alt="" />
        </Box>
        <Box display="flex" justifyContent="center" flexGrow="1">
          <img src={stepper1} className={classes.stepperImg} alt="" />
        </Box>
      </>,
      description: <>
        <Box px={4}>
          <Box>{`Download T&C Document and get them signed from homeowner.`}</Box>
          <Box className={classes.stepperLink} mt={4} onClick={() => { DownloadFile(process.env.PUBLIC_URL + '/HECOSDP_Forms.zip') }}>{`Download Program Documents here`}</Box>
        </Box>
      </>,
    },
    {
      header: <>
        <Box className={classes.headerNumber}>
          <img src={two} className={classes.stepperNumberImg} alt="" />
        </Box>
        <Box display="flex" justifyContent="center" flexGrow="1">
          <img src={stepper2} className={classes.stepperImg} alt="" />
        </Box>
      </>,
      description:
        <Box px={10}>
          <Box component="span">{`Fill homeowner details, upload signed T&C document and application summary document received from HECO `}</Box>
          <Box className={classes.stepperLink} onClick={() => history.push('/application')} component="span">{`here.`}</Box>
          <Box component="span">{` Once done, submit the application for Enphase review.`}</Box>
        </Box>,
    },
    {
      header: <>
        <Box className={classes.headerNumber}>
          <img src={three} className={classes.stepperNumberImg} alt="" />
        </Box>
        <Box display="flex" justifyContent="center" flexGrow="1">
          <img src={stepper3} className={classes.stepperImg} alt="" />
        </Box>
      </>,
      description:
        <Box px={16}>{`Enphase either approves or rejects the application. In case of rejection, you can view the reason for rejection and re-submit the application.`}</Box>,
    },
    {
      header: <>
        <Box className={classes.headerNumber}>
          <img src={four} className={classes.stepperNumberImg} alt="" />
        </Box>
        <Box display="flex" justifyContent="center" flexGrow="1">
          <img src={stepper4} className={classes.stepperImg} alt="" />
        </Box>
      </>,
      description:
        <Box>
          <Box>{`Good Job! Once approved by Enphase, the site is successfully enrolled in the program.`}</Box>
          <Box mt={1}>
            <Box component="span">{`Homeowner’s battery will discharge during the dispatch timings to gather the 7 days Verification Evidence for the site. Once ready, Verification Evidence Report will be mailed to Installer.`}</Box>
          </Box>
        </Box>,
    },
  ]
  
  const maxSteps = 4

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const getProcessFlow = () => {
    return (
      <Box>
        <Box className={classes.processCard}>
          <Box display="flex">
            {steps[activeStep].header}
          </Box>
          <Box className={classes.stepperContent} p={2} mt={2}>
            {steps[activeStep].description}
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" p={1}>
          <Button
            size="small"
            className={classes.processButton}
            onClick={handleBack}
            disabled={activeStep === 0}
            style={{ visibility: activeStep === 0 ? 'hidden' : '' }}
          >
            <KeyboardArrowLeft />
            BACK
          </Button>
          <Box display="flex" alignItems="center">
            {steps.map((step, index) => (
              <Box key={index} color="primary" className={`${activeStep === index ? classes.customDotActive : classes.customDot}`} onClick={() => setActiveStep(index)} />
            ))}
          </Box>
          <Button
            size="small"
            className={classes.processButton}
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
            style={{ visibility: activeStep === maxSteps - 1 ? 'hidden' : '' }}
          >
            NEXT
            <KeyboardArrowRight />
          </Button>
        </Box>
      </Box >
    )
  }

  return (
    <CustomDialog classes={{ paper: classes.customPaper }} fullWidth open={props.open} title="" content={getProcessFlow()} handleClose={props.handleClose} />
  )
}

export default Process